export default "__VITE_ASSET__BJeDzdUI__"